import { render, staticRenderFns } from "./BudgetDashboardChart.vue?vue&type=template&id=121b5ad3&scoped=true&"
import script from "./BudgetDashboardChart.vue?vue&type=script&lang=js&"
export * from "./BudgetDashboardChart.vue?vue&type=script&lang=js&"
import style0 from "./BudgetDashboardChart.vue?vue&type=style&index=0&id=121b5ad3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121b5ad3",
  null
  
)

export default component.exports